<template>
  <div class="page">
    <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'5px'}">
      <custom-paging-dragging-list
        ref="table"
        rowKey="commodityBrandId"
        :columns="columns"
        :queryParams="queryParams"
        :requestPromise="loadPromise"
        @draggable="onDraggable"
      >
        <div slot="indexSlots" slot-scope="data">{{ data.index + 1 }}</div>
        <div class="image-table" slot="imageSlots" slot-scope="data">
          <CustomImage :imageUrl="data.record.proImg" :width="120"></CustomImage>
        </div>
      </custom-paging-dragging-list>
    </a-card>
  </div>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'BrandSaleList',
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      hotProList: [],
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' }
        },
        {
          title: '品牌ID',
          dataIndex: 'commodityBrandId'
        },
        {
          title: '封面图片',
          dataIndex: 'proImg',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '品牌名称',
          dataIndex: 'commodityBrandName'
        }
        // {                  未发现使用，隐藏  ---- DX
        //   title: '操作',
        //   dataIndex: 'action',
        //   width: '100px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ]
    }
  },
  mounted() {

  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getUserService().post('user/merchantInfo/queryCommodityBrandSection', params)
    },
    // 拖拽排序功能
    onDraggable(params) {
      this.getLogUtils().logWithTag('==onDraggable排序==', params)
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.commodityBrandId
      })
      this.getLogUtils().logWithTag('==idList==', idList)
      this.getHttpServices().getUserService().post('user/merchantInfo/commodityBrandSectionOrderBy', {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }).then(res => {
        this.getLogUtils().logWithTag('==onDraggable==', res)
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../../CustomPage.less');
</style>